import React from 'react';

export const StatusBadge = ({ status }) => (
    <span className={`badge ${status.badgeClass}`}>{status.label}</span>
);
